module.exports = __webpack_public_path__ + "static/media/icon-google-play.abfba9c1.svg";